<template>
  <draggable
    tag="ul"
    class="h-min-200 h-100 pl-0"
    v-model="rounds"
    v-bind="dragOptions"
    :move="onMove"
    @change="round_added"
    @start="isDragging = true"
    @end="isDragging = false"
  >
    <transition-group type="transition" :name="'tr-list'" class="d-block h-100">
      <JobRoundDisplay
        v-for="round in rounds"
        :key="round.id"
        :round="round"
        :schedule_index="schedule_index"
        :week_index="week_index"
        :day_index="day_index"
        @saved="_reload"
      />
    </transition-group>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import JobRoundDisplay from "@/components/job/JobRoundDisplay.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "JobDayDisplay",
  props: {
    schedule_index: {
      type: Number,
      required: true,
    },
    week_index: {
      type: Number,
      required: true,
    },
    day_index: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isDragging: false,
    delayedDragging: false,
    rounds: [],
  }),
  computed: {
    ...mapState("schedule", ["schedule_group_weeks"]),
    ...mapState("status", ["job_dragging_enabled"]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.job_dragging_enabled,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.rounds = this.schedule_group_weeks[this.schedule_index][
        this.week_index
      ].days[this.day_index].rounds;
    });
  },
  watch: {
    schedule_group_weeks: {
      deep: true,
      handler() {
        this.rounds = this.schedule_group_weeks[this.schedule_index][
          this.week_index
        ].days[this.day_index].rounds;
      },
    },
    schedule_index(new_value) {
      this.rounds = this.schedule_group_weeks[new_value][this.week_index].days[
        this.day_index
      ].rounds;
    },
    week_index(new_value) {
      this.rounds = this.schedule_group_weeks[this.schedule_index][
        new_value
      ].days[this.day_index].rounds;
    },
    day_index(new_value) {
      this.rounds = this.schedule_group_weeks[this.schedule_index][
        this.week_index
      ].days[new_value].rounds;
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
  methods: {
    ...mapActions("schedule", ["moveScheduleRoundTo"]),
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    round_added({ added }) {
      if (added) {
        this.moveScheduleRoundTo({
          schedule_index: this.schedule_index,
          schedule_round: added.element,
          to_week_index: this.week_index,
          to_day_index: this.day_index,
        });
      }
    },
    _reload() {
      this.rounds = this.schedule_group_weeks[this.schedule_index][
        this.week_index
      ].days[this.day_index].rounds;
    },
  },
  components: {
    draggable,
    JobRoundDisplay,
  },
};
</script>
